import { SETTINGS_CI_BULK_IMPORT } from '@/shared/config/routes';

export const CI_BULK_IMPORT_JOB_PARAM = 'job_id';

export const getCIBulkImportURL = (jobId?: string | null) => {
  if (!jobId) return SETTINGS_CI_BULK_IMPORT;
  const params = new URLSearchParams({ [CI_BULK_IMPORT_JOB_PARAM]: jobId });
  return `${SETTINGS_CI_BULK_IMPORT}?${params}`;
};
